<form [formGroup]="slotsForm" id="ticketsForm" class="mb-3">
  <div formArrayName="days">
    <div class="row justify-content-center" *ngFor="let day of getDays().controls; let dayIndex = index">
      <div class="cardbg-white my-3">
        <div class="row">
      <div [formGroupName]="dayIndex" *ngIf="!repeatScheduleSelected || dayIndex==0">
        <p [ngClass]="{'text-danger': invalidDay == selectedDays[dayIndex]}">{{ 'Sellers.Products.Day' | translate }} {{ selectedDays[dayIndex] }}</p>
        <div formArrayName="slots">
          <div *ngFor="
              let slot of getDaySlots(dayIndex).controls;
              let slotIndex = index" class="row justify-content-center">
            <div [formGroupName]="slotIndex" class="row justify-content-center align-items-end mb-3">
              <app-hidden [fieldObject]="slotFields.id" [formControlRef]="slot.controls[slotFields.id.fieldName]"
                id="ticket-quantity">
              </app-hidden>
              <div class="col-sm-5 col-md-3 mb-3">
                <mat-form-field appearance="outline" class="w-100">

                <mat-label >
                  {{ 'Sellers.Products.StartingTime' | translate }}
                </mat-label>
                <mat-select   formControlName="startAt" class="product">
                  <mat-option *ngFor="let fieldValue of bookingTimes" [value]="fieldValue.name">
                    {{fieldValue.name}}
                  </mat-option>
                </mat-select>
                <mat-error class="text-danger"
                      *ngIf="slot.controls['startAt'].invalid && slot.controls['startAt'].errors.required && slot.controls['startAt'].touched">
                  {{ 'Sellers.Products.FieldRequired' | translate }}
                </mat-error>
              </mat-form-field>

              </div>
              <div class="col-sm-5 col-md-3 mb-3">
                <mat-form-field appearance="outline" class="w-100">

                <mat-label >
                  {{ 'Sellers.Products.ClosingTime' | translate }}
                </mat-label>
                <mat-select  class="product" formControlName="endAt">
                  <mat-option *ngFor="let fieldValue of bookingTimes" [value]="fieldValue.name">
                    {{fieldValue.name}}
                  </mat-option>
                </mat-select>
                <mat-error class="text-danger"
                      *ngIf="slot.controls['endAt'].invalid && slot.controls['endAt'].errors.required && slot.controls['endAt'].touched">
                  {{ 'Sellers.Products.FieldRequired' | translate }}
                </mat-error>
                <mat-error class="text-danger"
                      *ngIf="slot.controls['endAt'].invalid && slot.controls['endAt'].errors.customPattern && slot.controls['endAt'].touched">
                  {{ 'Sellers.Products.CloseMustBeBigger' | translate }}
                </mat-error>
              </mat-form-field>
              </div>
              <div class="col-1 px-0 mb-3 input-icon"  >
                <mat-icon   class="delete-icon text-danger p-0" style="transform: scale(1.3);" (click)="removeDaySlot(dayIndex, slotIndex)">delete
                </mat-icon>
              </div>
            </div>
          </div>
        </div>
        <div class="text-center">
          <button  id="adBtn" class="btn btn-success col-md-7 mb-3" (click)="addDaySlots(dayIndex)">
            {{ 'Sellers.Products.Add' | translate }}
          </button>
        </div>
        <ng-container *ngIf="dayIndex==0">
          <app-schedule-repeat-form (scheduleRepeatConfirm)="onRepeatSchedule($event)"
          [slectedDateSchedue]="day.value.day"
          [isDayScheduleValid]="day.valid"></app-schedule-repeat-form>
        </ng-container>
      </div>
    </div>
  </div>
  </div>
  </div>
</form>
